import React, { FunctionComponent } from 'react'
import { Link } from 'react-router-dom'
import { RefiMeNow } from '../icons/refiMeNow'

export interface Props {
  title: string
  icon: string
  to: string
  target?: string
  disabledMessage?: string
}

const hubIcon = (icon: string) => {
  switch (icon) {
    case 'refiMeNow':
      return <RefiMeNow colorClass="hub-link__icon-color" />
    default:
      return <div className={`hub-link__icon ${icon}`} />
  }
}

export const HubLink: FunctionComponent<Props> = ({
  title,
  icon,
  to,
  target,
  disabledMessage,
}) => {
  if (disabledMessage) {
    return (
      <div className="hub-link">
        <div
          className="hub-link__link badge-gate--disabled"
          title={disabledMessage}
        >
          <div className="hub-link__box">{hubIcon(icon)}</div>
        </div>
        <div className="hub-link__title">
          <p>{title}</p>
        </div>
      </div>
    )
  }

  //check for external link
  if (/^https?:\/\//.test(to)) {
    return (
      <div className="hub-link">
        <a href={to} target={target} className="hub-link__link">
          <div className="hub-link__box">{hubIcon(icon)}</div>
        </a>
        <div className="hub-link__title">
          <p>{title}</p>
        </div>
      </div>
    )
  }

  return (
    <div className="hub-link">
      <Link to={to} target={target} className="hub-link__link">
        <div className="hub-link__box">
          <div className={`hub-link__icon ${icon}`} />
        </div>
      </Link>
      <div className="hub-link__title">
        <p>{title}</p>
      </div>
    </div>
  )
}
